module.exports = __webpack_public_path__ + "static/img/7.8b8379d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/7.png
// module id = NQUo
// module chunks = 1